import { render, staticRenderFns } from "./SearchOverview.vue?vue&type=template&id=24ac07f8"
import script from "./SearchOverview.vue?vue&type=script&lang=js"
export * from "./SearchOverview.vue?vue&type=script&lang=js"
import style0 from "./SearchOverview.vue?vue&type=style&index=0&id=24ac07f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports